import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductAddon } from '../../core/models/interfaces-general';
@Component({
    selector: 'app-product-addon-selector',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="flex flex-col gap-2">
      <span class="text-xs font-semibold text-gray-600 flex items-center gap-1">
        <svg class="w-4 h-4 text-rose-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12v9H4v-9m16 0H4m16 0l-2-5a2 2 0 00-2-1h-1a2 2 0 00-2 2v4m0 0V7a2 2 0 00-2-2H9a2 2 0 00-2 1l-2 5" /></svg>
        Añade un complemento
      </span>
      
      <!-- SLIDER / CAROUSEL HORIZONTAL DE COMPLEMENTOS -->
      <div class="flex gap-3 overflow-x-auto pb-2 scrollbar-thin">
        <div 
          *ngFor="let addon of addons"
          (click)="toggleAddon(addon)"
          [ngClass]="{
            'border-rose-500 bg-rose-50/30': isSelected(addon),
            'border-gray-200 hover:border-gray-300': !isSelected(addon)
          }"
          class="flex-shrink-0 w-28 p-2 border-2 rounded-2xl cursor-pointer transition-all duration-200 bg-white flex flex-col items-center text-center select-none"
        >
          <img [src]="addon.imageUrl" [alt]="addon.name" class="w-12 h-12 object-contain mb-1" />
          <span class="text-[11px] font-medium text-gray-700 line-clamp-1 leading-tight">
            {{ addon.name }}
          </span>
          <span class="text-xs font-bold text-rose-500 mt-1">
            +S/ {{ addon.price.toFixed(2) }}
          </span>
        </div>
      </div>
    </div>
  `
})
export class ProductAddonSelectorComponent {
    @Input({ required: true }) addons: ProductAddon[] = [];
    @Output() selectionChange = new EventEmitter<ProductAddon[]>();

    selectedAddons: ProductAddon[] = [];

    toggleAddon(addon: ProductAddon) {
        const index = this.selectedAddons.findIndex(item => item.id === addon.id);
        if (index > -1) {
            this.selectedAddons.splice(index, 1);
        } else {
            this.selectedAddons.push(addon);
        }
        this.selectionChange.emit(this.selectedAddons);
    }

    isSelected(addon: ProductAddon): boolean {
        return this.selectedAddons.some(item => item.id === addon.id);
    }
}